module.exports = __webpack_public_path__ + "static/img/children11.c6e6c4a5.jpg";